import React, { useCallback, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { CareCreditCardContentDetail } from './CareCreditCardContentDetail';
import {
  SecondaryReimbursementMethodList,
} from './SecondaryReimbursementMethodList';
import { REIMBURSEMENT_METHODS } from '../../../../constants';
import { CheckContent } from './CheckContent';
import {
  SecondaryDirectDepositContent,
} from './SecondaryDirectDepositContent.js';
import { CareCreditAgreement } from './CareCreditAgreement.js';

export const STEPS_CARE_CREDIT = {
  assignmentAgreement: 3,
  cardDetails: 0,
  secondarySelection: 1,
  secondarySelectionDetail: 2,
};

const CareCreditContent = ({ cancelAll = () => { }, onCancel = () => { } }) => {
  const [step, setStep] = useState(STEPS_CARE_CREDIT.cardDetails);
  const secondaryMethod =
    useSelector(({ billingPayments }) => (
      billingPayments.reimbursementData.secondaryMethod), shallowEqual);
  const { secondaryReimbursementMethod } = secondaryMethod;

  const goStep = useCallback((newStep) => () => {
    setStep(newStep);
  }, []);

  switch (step) {
    case STEPS_CARE_CREDIT.cardDetails:
      return (
        <CareCreditCardContentDetail
          goBack={onCancel}
          goNextStep={goStep(STEPS_CARE_CREDIT.secondarySelection)}
        />
      );
    case STEPS_CARE_CREDIT.secondarySelection:
      return (
        <SecondaryReimbursementMethodList
          goBack={goStep(STEPS_CARE_CREDIT.cardDetails)}
          goNext={goStep(STEPS_CARE_CREDIT.secondarySelectionDetail)}
        />
      );
    case STEPS_CARE_CREDIT.secondarySelectionDetail:
      return secondaryReimbursementMethod === REIMBURSEMENT_METHODS.check
        ? (
          <CheckContent
            goNext={goStep(STEPS_CARE_CREDIT.assignmentAgreement)}
            onCancel={goStep(STEPS_CARE_CREDIT.secondarySelection)}
          />
        )
        : (
          <SecondaryDirectDepositContent
            goNext={goStep(STEPS_CARE_CREDIT.assignmentAgreement)}
            onCancel={goStep(STEPS_CARE_CREDIT.secondarySelection)}
          />
        );
    case STEPS_CARE_CREDIT.assignmentAgreement:
      return (
        <CareCreditAgreement
          cancelAll={cancelAll}
          onCancel={goStep(STEPS_CARE_CREDIT.secondarySelectionDetail)}
        />
      );
    default:
      return null;
  }
};

export { CareCreditContent };
